import React, { useState } from "react";
import bgImg from "../Images/hero.jpeg";
import Header from "./Header";
import Navbar from "./Navbar";
// import { FaPhoneAlt } from "react-icons/fa";
import Footer from "./Footer";

const Contact = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const text = `
Hey Dellson! I have a requirement.

Name: ${formData.name || "-"}
Email: ${formData.email || "-"}
Mobile: ${formData.mobile || "-"}
Message: ${formData.message || "-"}
    `.trim();

    const encodedText = encodeURIComponent(text);
    const waNumber ="9919220008";
    const url = `https://wa.me/${waNumber}?text=${encodedText}`;

    window.open(url, "_blank");
    setLoading(false);
  };

  return (
    <>
      <Header />
      <Navbar />

      {/* HERO */}
      <section
        className="container-fluid d-flex align-items-center justify-content-center text-center"
        style={{
          minHeight: "45vh",
          backgroundImage: `linear-gradient(
            rgba(255, 201, 74, 0.88),
            rgba(255, 201, 74, 0.88)
          ), url(${bgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <h1 className="fw-bold display-5 mb-3 text-dark">Contact Us</h1>
          <p className="mx-auto text-dark" style={{ maxWidth: "720px", fontSize: "18px" }}>
            We value the opportunity to connect with our customers and answer
            any questions they may have.
          </p>
        </div>
      </section>

      {/* FORM */}
      <section className="container-fluid py-5">
        <div className="container">
          <div
            className="mx-auto p-5"
            style={{
              maxWidth: "900px",
              backgroundColor: "#eef5ff",
              borderRadius: "12px",
            }}
          >
            <h2 className="fw-bold text-center mb-3">Leave Us a Message</h2>

            <p className="text-center text-muted mb-5">
              Fill out the form, and one of our friendly customer service
              representatives will be in touch with you shortly.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="row mb-4">
                <div className="col-md-6 mb-3 mb-md-0">
                  <label className="fw-semibold mb-2">Full Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="fw-semibold mb-2">Email *</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="fw-semibold mb-2">Phone Number *</label>
                <input
                  type="tel"
                  className="form-control"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="fw-semibold mb-2">Message *</label>
                <textarea
                  className="form-control"
                  rows="5"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn w-100 py-3 fw-bold text-white"
                style={{
                  backgroundColor: "#224b8f",
                  borderRadius: "8px",
                }}
                disabled={loading}
              >
                {loading ? "SENDING..." : "SUBMIT"}
              </button>
            </form>
          </div>
        </div>
      </section>

 <div className="container my-4 px-3">
  <div className="ratio ratio-16x9">
    <iframe
      title="Bindki Location Map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57363.32001196352!2d80.50448877950195!3d26.026765882632716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399c893e9543f5c9%3A0xc30e080e72942f3f!2sBindki%2C%20Uttar%20Pradesh%20212635!5e0!3m2!1sen!2sin!4v1768640539433!5m2!1sen!2sin"
      allowFullScreen
      loading="lazy"
      className="border rounded w-100"
    ></iframe>
  </div>
</div>

<Footer/>

    </>
  );
};

export default Contact;
